/* src/components/pages/Cesionesdeu.jsx - Modificado el 17-03-2026 */
/* ------------- Contralodor de Cesiones por deudor -------------- */

import React, { useState } from 'react';

import {
  TextField,
  Typography,
  Divider,
  MenuItem,
  Button,
  Box,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Tooltip,
  Stack,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  FormControlLabel,
} from '@mui/material';

import api from '../../services/api.js'; // Api Interceptor en vez de Axios

import { DataGrid } from '@mui/x-data-grid';
import { esES } from '@mui/x-data-grid/locales';
import { CustomToolbar } from "../../components/datagrid/CustomToolbar";
import DataGridSkeleton from "../../components/datagrid/DataGridSkeleton";

import { exportPdfAsync, downloadBlob } from "../utils/exportUtils";

import { useAuth } from "../../context/AuthContext"; // token

import { useFeedback } from '../../context/FeedbackContext'; // Mensajes breves

import { normalizeRut } from "../utils/rutUtils";
import { formatFecha } from "../utils/dateUtils";
import { formatoCLP } from "../utils/montoclpUtils";

import {
  RiFolderDownloadLine,
  RiShareBoxFill,
  RiFileSearchLine,
  RiFileList2Fill,
  RiFileCopy2Fill,
  RiSlackFill,
  RiFilePdf2Fill
} from "react-icons/ri";

/* Campos para exportar a Csv */
const CSV_FIELDS = [
  { key: 'feccesion', label: 'Fecha Cesión',},
  { key: 'montoces', label: 'Monto Cesión'},
  { key: 'rutcedente', label: 'Rut Cedente',},
  { key: 'nomcedente', label: 'Nombre Cedente',},
  { key: 'rutcesionario', label: 'Rut Cecionario',},
  { key: 'nomcesionario', label: 'Nombre Cecionario',},
  { key: 'tipodte', label: 'Dte' },
  { key: 'folio', label: 'Folio'},
  { key: 'fecemi', label: 'Fecemi'},
  { key: 'montodte', label: 'Monto'},
];

const Cesionesdeu = ({ modo }) => {
  const { user } = useAuth();

  const [datacesiones, setCesiones] = useState([]);
  const [loading, setLoading] = useState(false);

  const [estado, setEstado] = useState('PENDIENTES');
  const [ano, setAno] = useState(new Date().getFullYear()); // Inicializa con el año actual
  const [mes, setMes] = useState(0); // Inicialmente "Todos"
  const [Estadosel, setEstadosel] = useState(0); // Esta es la constante que almacenará el valor numérico
  
  const [generandoPdf, setGenerandoPdf] = useState(false);

  const [openCsvDialog, setOpenCsvDialog] = useState(false);

  /* Selecciona todos los campos para Csv */
  const [selectedCsvFields, setSelectedCsvFields] = useState(
    CSV_FIELDS.map(f => f.key)
  );

  /* Estados para paginación desde el servidor */
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [rowCount, setRowCount] = useState(0);
  
  /* Dialogo y confirmación */
  const { showFeedback } = useFeedback(); // Mensajes breves no bloqueantes

  const [openDialog, setOpenDialog] = useState(false);
  const [rowDetails, setRowDetails] = useState(null);

  const [totalMontoCes, setTotalMontoCes] = useState(0);
  const [totalMontoDte, setTotalMontoDte] = useState(0);
  const [cantidadCesiones, setCantidadCesiones] = useState(0);

  /* manejo del cambio de estado */
  const handleEstadoChange = (e) => {
    const selectedValue = e.target.value;
    setEstado(selectedValue);

    /* Asigna el valor numérico correspondiente a estadosel */
    if (selectedValue === 'PENDIENTES') {
      setEstadosel(0);
    } else if (selectedValue === 'EN NÓMINA') {
      setEstadosel(1);
    } else if (selectedValue === 'PAGADAS') {
      setEstadosel(2);
    } else if (selectedValue === 'TODAS') {
      setEstadosel(3);
    }
  };

  /* Cálculo dinámico de los años */
  const currentYear = new Date().getFullYear(); // Año actual
  const years = Array.from({ length: 7 }, (_, index) => currentYear - index);

  /* Manejo del cambio del año */
  const handleAnoChange = (e) => {
    setAno(e.target.value);
  };

  /* Manejo del cambio del mes */
  const handleMesChange = (e) => {
    setMes(e.target.value);
  };

  /* helper para formato de monto clp */
  const renderMontoCLP = (value) => (
    <Box
      sx={{
        textAlign: 'center',
        fontSize: '0.9rem',
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        width: '100%',
        // fontWeight: 'bold',
      }}
    >
      {formatoCLP(value)}
    </Box>
  );

  /* Función para obtener los datos. recibe la página solicitada */
  const fetchCesiones = async ({ page = 0, pageSize = 20 } = {}) => {
    if (!user.usuario) {
      showFeedback({
        message: "Debe ingresar el Rut",
        severity: "warning",
      });
      return;
    }

    setLoading(true);

    try {
      const RutCli = normalizeRut(user.usuario);
      const Anoaconsultar = ano;
      const Mesaconsultar = mes;
      const Idban = 0; // no incluir banco

      const response = await api.post("/cesiones/getcesiones", {
        RutCli,
        Tipo: 'DEUDOR',
        Estadosel,
        Anoaconsultar,
        Mesaconsultar,
        Idban,
        page,
        pageSize,
      });

      if (response.data.success && response.data.rows) {
        const { rows, totales, total } = response.data;

        setCesiones(rows);
        setRowCount(total);

        setTotalMontoCes(totales.montoces);
        setTotalMontoDte(totales.montodte);
        setCantidadCesiones(totales.cantidad);

        if (response.data.rows.length === 0) {
          showFeedback({
            message: "No se encontraron registros para los parámetros ingresados",
            severity: "warning",
          });
        }

      } else {
        setCesiones([]);
        setTotalMontoCes(0);
        setTotalMontoDte(0);
        setCantidadCesiones(0);
        setRowCount(0);

        showFeedback({
          message:
            "No se encontraron registros para los parámetros ingresados",
          severity: "warning",
        });
      }
    } catch (err) {
      setCesiones([]);
      setRowCount(0);

      showFeedback({
        message:
          "No fue posible obtener su solicitud, por favor intente más tarde.",
        severity: "warning",
      });
    } finally {
      setLoading(false);
    }
  };

  /* Mostrar los detalles de la fila seleccionada */
  const handleRowClick = (row) => {
    setRowDetails(row);
    setOpenDialog(true);  /* Abrir el diálogo con los detalles */
  };

  /* exportar a pdf todos los datos de la tabla */
  const exportToPDF = async () => {
    exportPdfAsync({
      endpointBase: "/cesiones/pdf",
      payload: {
        RutCli: normalizeRut(user.usuario),
      },
      onStart: () => setGenerandoPdf(true),
      onFinish: () => setGenerandoPdf(false),
      onError: (msg) => {
        setGenerandoPdf(false);
        showFeedback({
          message: msg,
          severity: "error",
        });
      },
    });
  };

  /* Helpers de Selección de campos para exportar a Csv */
  const toggleCsvField = (fieldKey) => {
    setSelectedCsvFields(prev =>
      prev.includes(fieldKey)
        ? prev.filter(k => k !== fieldKey)
        : [...prev, fieldKey]
    );
  };

  /* Llama a crear Csv */
  const handleExportCsv = async () => {
    try {
      const RutCli = normalizeRut(user.usuario);

      const response = await api.post('/cesiones/csv',
        {
          RutCli,
          fields: selectedCsvFields,
        },
        {
          responseType: 'blob',
        }
      );

      downloadBlob(response.data, "cesiones.csv");
      setOpenCsvDialog(false);

    } catch (error) {
      showFeedback({
        message: 'No fue posible exportar el CSV',
        severity: 'error',
      });
    }
  };


  /* Configuración de MUI DataGrid */
  const columns = [
    {
      field: "pagada",
      headerName: "Estado",
      width: 130,
      headerAlign: "center",
      align: "center",
      sortable: true,

      renderCell: (params) => {
        const pagada = params.value;

        let variant;
        let label;

        if (pagada === 0) {
          variant = "warning";   // Pendiente
          label = "Pendiente";
        } else if (pagada === 1) {
          variant = "success";   // En nómina (flujo OK)
          label = "En Nómina";
        } else if (pagada === 2) {
          variant = "paid";   // Pagada
          label = "Pagada";
        }

        if (!variant) return null;

        return (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={(theme) => {
                const status = theme.custom.ui.status?.[variant];

                return {
                  backgroundColor: status?.bg,
                  color: status?.text,
                  border: `1px solid ${status?.border}`,

                  padding: "5px 10px",
                  borderRadius: "5px",
                  minWidth: 110,
                  height: 22,

                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",

                  fontSize: "0.75rem",
                  fontWeight: 600,
                  letterSpacing: "0.02em",
                };
              }}
            >
              {label}
            </Box>
          </Box>
        );
      },
    },
    {
      field: 'pdf',
      headerName: 'PDF',
      width: 50,
      sortable: false,
      filterable: false,
      align: 'center',
      headerAlign: 'center',
      disableColumnMenu: true,

      renderCell: (params) => {
        const { uuid } = params.row;

        const handleOpenPDF = async () => {
          if (!uuid) return;

          try {
            const response = await api.post('/cesiones/getcesionespdf',
              { uuid },
              { responseType: 'blob' }
            );

            const pdfBlob = new Blob([response.data], {
              type: 'application/pdf',
            });

            const url = window.URL.createObjectURL(pdfBlob);
            window.open(url, '_blank');

            setTimeout(() => {
              window.URL.revokeObjectURL(url);
            }, 1000);

          } catch (error) {
            showFeedback({
              message: 'No fue posible obtener el Pdf',
              severity: 'error',
            });
          }
        };

        return (
          <Button
            variant="contained"
            aria-label="Abrir PDF"
            onClick={handleOpenPDF}
            sx={{
              backgroundColor: (theme) => theme.custom.ui.primaryAction,
              color: (theme) => theme.custom.ui.primaryActionText,
              minWidth: 0,
              padding: 0,
              width: 32,
              height: 24,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              '&:hover': {
                backgroundColor: (theme) =>
                  theme.custom.ui.primaryActionHover,
              },
            }}
          >
            <RiFilePdf2Fill size={20} />
          </Button>
        );
      },
    },
    {
      field: 'detalle',
      headerName: "Info",
      width: 70,
      sortable: false,
      filterable: false,
      align: 'center',
      headerAlign: 'center',
      disableColumnMenu: true,
      renderCell: (params) => (
        <Button
          variant="contained"
          onClick={() => handleRowClick(params.row)}
          sx={{
            backgroundColor: (theme) => theme.custom.ui.primaryAction,
            color: (theme) => theme.custom.ui.primaryActionText,
            minWidth: 0,
            padding: 0,
            width: 32,
            height: 24,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '&:hover': {
              backgroundColor: (theme) =>
                theme.custom.ui.primaryActionHover,
            },
          }}
        >
          <RiFileList2Fill size={22} />
        </Button>
      ),
    },
    {
      field: "folionc",
      headerName: "NC",
      width: 70,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) =>
        params.value > 0 ? (
          <Tooltip title={`Número NC: ${params.value}`} arrow>
            <span>
              <RiFileCopy2Fill size={22} color="red" />
            </span>
          </Tooltip>
        ) : null,
    },
    {
      field: 'feccesion',
      headerName: 'Fecha Ces.',
      width: 140,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => formatFecha(params.value),
    },
    {
      field: 'montoces',
      headerName: "Monto Ces.",
      width: 140,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        return renderMontoCLP(params.value);
      },
    },
    {
      field: 'fecrec',
      headerName: 'Recepción',
      width: 120,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => formatFecha(params.value),
    },
    {
      field: 'dias_reclamo',
      headerName: 'Días Reclamo',
      width: 150,
      align: 'center',
      headerAlign: 'center',
      sortable: true,

      renderCell: (params) => {
        const dias = params.value;

        if (dias === null || dias === undefined) {
          return (
            <Box sx={{ fontSize: '0.75rem', opacity: 0.5 }}>
              -
            </Box>
          );
        }

        let variant = 'success';
        let label = 'OK';

        if (dias <= 0) {
          variant = 'error';
          label = 'Vencido';
        } else if (dias <= 3) {
          variant = 'warning';
          label = 'Urgente';
        }

        return (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={(theme) => {
                const status = theme.custom.ui.status?.[variant];

                return {
                  backgroundColor: status?.bg,
                  color: status?.text,
                  border: `1px solid ${status?.border}`,
                  padding: "5px 10px",
                  borderRadius: "5px",
                  minWidth: 110,
                  height: 22,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "0.75rem",
                  fontWeight: 600,
                };
              }}
            >
              {dias} · {label}
            </Box>
          </Box>
        );
      },
    },
    {
      field: 'rutcedente',
      headerName: "Cedente",
      width: 130,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'nomcedente',
      headerName: "Razón Social",
      width: 350,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'rutcesionario',
      headerName: "Cesionario",
      width: 130,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'nomcesionario',
      headerName: "Razón Social",
      width: 350,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'tipodte',
      headerName: "Dte",
      width: 350,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'folio',
      headerName: "Folio",
      width: 140,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'fecemi',
      headerName: "Fecha Emisión",
      width: 120,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => formatFecha(params.value),
    },
    {
      field: 'montodte',
      headerName: "Monto",
      width: 140,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        return renderMontoCLP(params.value);
      },
    },
    {
      field: 'idban',
      headerName: 'Banco',
      width: 80,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'nomban',
      headerName: 'Nombre',
      width: 300,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'ctacte',
      headerName: 'Ctacte',
      width: 160,
      align: 'center',
      headerAlign: 'center',
    },
  ];


  /* Render */
  return (
    <Box sx={{ width: '100%', pt: 0, overflow: 'visible' }}>
      {/* Barra de Controles */}
      <Stack
        direction="row"
        spacing={1}
        useFlexGap
        flexWrap="wrap"
        alignItems="center"
        sx={{
          mb: 1,
          flexShrink: 0,       // 👈 NO se colapsa
        }}
      >
        {/* Rut */}
        <TextField
          label="Rut"
          value={user?.usuario || ""}
          size="small"
          disabled
          slotProps={{
            inputLabel: { shrink: true },
          }}
          sx={{
            minWidth: 140,
            flexShrink: 0,
            "& .MuiInputBase-root": {
              backgroundColor: (theme) => theme.custom.ui.readonlyBg,
            },

            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.custom.ui.readonlyText,
              textAlign: 'center',
              letterSpacing: '0.03em',
            },

            "& .MuiInputLabel-root, & .MuiInputLabel-root.Mui-disabled": {
              color: (theme) => theme.custom.ui.readonlyLabel,
            },
          }}
        />

        {/* Nombre */}
        <TextField
          label="Cliente"
          value={user?.nombre || ""}
          size="small"
          disabled
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          sx={{
            minWidth: 260,
            flexGrow: 1,
            flexShrink: 0,

            "& .MuiInputBase-root": {
              backgroundColor: (theme) => theme.custom.ui.readonlyBg,
            },

            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.custom.ui.readonlyText,
            },

            "& .MuiInputLabel-root, & .MuiInputLabel-root.Mui-disabled": {
              color: (theme) => theme.custom.ui.readonlyLabel,
            },
          }}
        />


        {/* Estado */}
        <TextField
          select
          id="estado-input"
          label="Estado"
          value={estado}
          onChange={handleEstadoChange}
          variant="outlined"
          fullWidth
          required
          sx={{
            width: 150,
            height: '40px', // Altura del TextField
            '& .MuiOutlinedInput-root': { height: '40px' },
            '& .MuiSelect-select': {
              textAlign: 'center',
            }
          }}
        >
          <MenuItem value="PENDIENTES">PENDIENTES</MenuItem>
          <MenuItem value="EN NÓMINA">EN NÓMINA</MenuItem>
          <MenuItem value="PAGADAS">PAGADAS</MenuItem>
          <MenuItem value="TODAS">TODAS</MenuItem>
        </TextField>


        {/* Año */}
        <TextField
          id="ano-input"
          select
          label="Año"
          value={ano}
          onChange={handleAnoChange}
          variant="outlined"
          required
          sx={{ width: 90,
            height: '40px', // Altura del TextField
            '& .MuiOutlinedInput-root': { height: '40px' },
            '& .MuiSelect-select': {
              textAlign: 'center',
            }
          }}
        >
          {/* Genera dinámicamente los años desde el año actual hasta 6 años atrás */}
          {years.map((year) => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </TextField>

        {/* Mes */}
        <TextField
          id="mes-input"
          select
          label="Mes"
          value={mes}
          onChange={handleMesChange}
          variant="outlined"
          required
          sx={{ width: 90,
            height: '40px', // Altura del TextField
            '& .MuiOutlinedInput-root': { height: '40px' },
            '& .MuiSelect-select': {
              textAlign: 'center',
            }
          }}
        >
          {/* Opción "Todos" con valor 0 */}
          <MenuItem key="todos-mes" value={0}>
            Todos
          </MenuItem>
          {Array.from({ length: 12 }, (_, i) => (
            <MenuItem key={i + 1} value={i + 1}>
              {i + 1}
              </MenuItem>
          ))}
        </TextField>


        {/* Botón Buscar */}
        <Button
          variant="contained"
          startIcon={<RiFileSearchLine size={18} />}
          onClick={() => {
            setPage(0);
            setRowCount(0);
            setCesiones([]);
            fetchCesiones({ page: 0, pageSize });
          }}
          sx={{
            minWidth: 110,
            height: 40,
            flexShrink: 0,

            backgroundColor: (theme) => theme.custom.ui.primaryAction,
            color: (theme) => theme.custom.ui.primaryActionText,

            '&:hover': {
              backgroundColor: (theme) => theme.custom.ui.primaryActionHover,
            },
          }}
        >
          Buscar
        </Button>

        {/* Botón Exportar a Pdf */}
        <Button
          variant="contained"
          startIcon={<RiFolderDownloadLine size={18} />}
          disabled={datacesiones.length === 0}
          onClick={exportToPDF}
          sx={{
            minWidth: 110,
            height: 40,
            flexShrink: 0,
            backgroundColor: (theme) => theme.custom.ui.exportActionBg,
            color: (theme) => theme.custom.ui.exportActionText,
            border: (theme) =>
              `1px solid ${theme.custom.ui.exportActionBorder}`,

            '&:hover': {
              backgroundColor: (theme) =>
                theme.custom.ui.exportActionBgHover,
            },
          }}
        >
          PDF
        </Button>

        {/* Botón Exportar a Csv */}
        <Button
          variant="contained"
          startIcon={<RiShareBoxFill size={18} />}
          disabled={datacesiones.length === 0}
          onClick={() => setOpenCsvDialog(true)}
          sx={{
            minWidth: 110,
            height: 40,
            backgroundColor: (theme) => theme.custom.ui.exportActionBg,
            color: (theme) => theme.custom.ui.exportActionText,
            border: (theme) =>
              `1px solid ${theme.custom.ui.exportActionBorder}`,

            '&:hover': {
              backgroundColor: (theme) =>
                theme.custom.ui.exportActionBgHover,
            },
          }}
        >
          CSV
        </Button>
      </Stack>


      {/* Cards de Totales */}
      <Stack
        direction="row"
        flexWrap="wrap"
        justifyContent="center"
        alignItems="flex-start"
        gap={1}   // espacio horizontal y vertical
        sx={{ mt: 1, mb: 1 }}
      >
        {/* CARD 1 - Cantidad de Cesiones */}
        <Card
          sx={{
            width: 130,
            minHeight: 52, // 👈 CLAVE: referencia vertical
            backgroundColor: (theme) => theme.custom.ui.surfaceBg,
            borderRadius: 2,
            boxShadow: (theme) => theme.custom.ui.surfaceShadow,
            display: 'flex', // 👈 importante
          }}
        >
          <Box
            sx={{
              flex: 1,                    // 👈 ocupa toda la altura
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',   // 👈 centrado real
              gap: 0.25,
              px: 1,
            }}
          >
            <Typography
            variant="caption"
              sx={{
                textAlign: 'center',
                color: (theme) => theme.custom.ui.brandAccent, // 👈 color de marca
                fontSize: '0.75rem',
                fontWeight: 600,       // 👈 un poco más de presencia
                letterSpacing: '0.02em',
              }}
            >
              Cesiones
            </Typography>

            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{
                color: (theme) => theme.custom.ui.textPrimary,
                fontSize: '0.85rem',
                lineHeight: 1.15,
                m: 0,
              }}
            >
              {cantidadCesiones}
            </Typography>
          </Box>
        </Card>

        {/* CARD 2 - Monto Cesiones */}
        <Card
          sx={{
            width: 130,
            minHeight: 52, // 👈 CLAVE: referencia vertical
            backgroundColor: (theme) => theme.custom.ui.surfaceBg,
            borderRadius: 2,
            boxShadow: (theme) => theme.custom.ui.surfaceShadow,
            display: 'flex', // 👈 importante
          }}
        >
          <Box
            sx={{
              flex: 1,                    // 👈 ocupa toda la altura
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',   // 👈 centrado real
              gap: 0.25,
              px: 1,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                textAlign: 'center',
                color: (theme) => theme.custom.ui.brandAccent, // 👈 color de marca
                fontSize: '0.75rem',
                fontWeight: 600,       // 👈 un poco más de presencia
                letterSpacing: '0.02em',
              }}
            >
              Monto Cesiones
            </Typography>

            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{
                color: (theme) => theme.custom.ui.textPrimary,
                fontSize: '0.85rem',
                lineHeight: 1.15,
                m: 0,
              }}
            >
              {formatoCLP(totalMontoCes)}
            </Typography>
          </Box>
        </Card>

        {/* CARD 3 - Monto Total */}
        <Card
          sx={{
            width: 130,
            minHeight: 52, // 👈 CLAVE: referencia vertical
            backgroundColor: (theme) => theme.custom.ui.surfaceBg,
            borderRadius: 2,
            boxShadow: (theme) => theme.custom.ui.surfaceShadow,
            display: 'flex', // 👈 importante
          }}
        >
          <Box
            sx={{
              flex: 1,                    // 👈 ocupa toda la altura
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',   // 👈 centrado real
              gap: 0.25,
              px: 1,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                textAlign: 'center',
                color: (theme) => theme.custom.ui.brandAccent, // 👈 color de marca
                fontSize: '0.75rem',
                fontWeight: 600,       // 👈 un poco más de presencia
                letterSpacing: '0.02em',
              }}
            >
              Monto Dtes
            </Typography>

            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{
                color: (theme) => theme.custom.ui.textPrimary,
                fontSize: '0.85rem',
                lineHeight: 1.15,
                m: 0,
              }}
            >
              {formatoCLP(totalMontoDte)}
            </Typography>
          </Box>
        </Card>
      </Stack>



      {/* Configuración MIU DataGrid */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 210px)', // ajusta según tu layout
          minHeight: 0,
        }}
       >
        <DataGrid
          rows={datacesiones}
          columns={columns}
          getRowId={(row) => row.id}
          loading={loading}
          density="compact"
          rowHeight={38}
          headerHeight={40}
          disableRowSelectionOnClick

          paginationMode="server"
          rowCount={rowCount}
          pageSizeOptions={[10, 20, 50, 100]}
          paginationModel={{ page, pageSize }}

          onPaginationModelChange={({ page: newPage, pageSize: newPageSize }) => {
            const isPageSizeChange = newPageSize !== pageSize;

            const finalPage = isPageSizeChange ? 0 : newPage;

            setPage(finalPage);
            setPageSize(newPageSize);

            fetchCesiones({
              page: finalPage,
              pageSize: newPageSize,
            });
          }}

          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          slots={{
            toolbar: CustomToolbar,
            loadingOverlay: DataGridSkeleton,
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 400 },
            },
          }}
          sx={{
            height: '100%',
            flex: 1,
            width: '100%',
            minWidth: 720,      // scroll horizontal cuando corresponde
            border: 'none',
            // accesibilidad / foco
            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
              outline: 'none',
            },
          }}
        />
      </Box>

      <Typography variant="caption" color="text.secondary">
        {rowCount.toLocaleString('es-CL')} registros encontrados
      </Typography>

      {/* Dialogo generando pdf */}
      <Dialog
        open={generandoPdf}
        aria-labelledby="generando-pdf-title"
        aria-describedby="generando-pdf-desc"

        maxWidth="xs"
        fullWidth
        slotProps={{
          paper: {
            sx: (theme) => ({
              borderRadius: 3,
              textAlign: 'center',
              backgroundColor: theme.custom.ui.modalBg,
              boxShadow: theme.custom.ui.modalShadow,
            }),
          },
        }}
      >
        <DialogContent>
          <Stack spacing={2} alignItems="center" py={2}>
            <CircularProgress
              size={42}
              thickness={4}
              sx={{
                color: (theme) => theme.custom.ui.focus,
              }}
            />

            <Typography id="generando-pdf-title" variant="body2">
              Generando reporte
            </Typography>

            <Typography
              id="generando-pdf-desc"
              variant="caption"
              color="text.secondary"
            >
              Estamos trabajando en ello…
            </Typography>
          </Stack>
        </DialogContent>
      </Dialog>

      {/* Dialogo selección de campos para Csv desde el backend */}
      <Dialog
        open={openCsvDialog}
        onClose={() => setOpenCsvDialog(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Box
            sx={{
              mb: 0,
              color: (theme) => theme.custom.ui.brandAccent,
              fontSize: '1.4rem'
            }}>
            Exportar CSV
          </Box>
        </DialogTitle>

        <Divider />

        <DialogContent>
          <Box sx={{ mb: 1, color: 'text.secondary', fontSize: '0.85rem' }}>
            Selecciona los campos que deseas incluir en el archivo.
          </Box>

          <Stack spacing={0.5}>
            {CSV_FIELDS.map(field => (
              <FormControlLabel
                key={field.key}
                control={
                  <Checkbox
                    checked={selectedCsvFields.includes(field.key)}
                    onChange={() => toggleCsvField(field.key)}
                  />
                }
                label={field.label}
              />
            ))}
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setOpenCsvDialog(false)}
            sx={{
              backgroundColor: (theme) => theme.custom.ui.secondaryActionBg,
              color: (theme) => theme.custom.ui.secondaryActionText,
              '&:hover': {
                backgroundColor: (theme) => theme.custom.ui.secondaryActionBgHover,
              },
            }}
          >
            Cancelar
          </Button>

          <Button
            variant="contained"
            disabled={selectedCsvFields.length === 0}
            onClick={handleExportCsv}
            sx={{
              backgroundColor: (theme) => theme.custom.ui.primaryAction,
              color: (theme) => theme.custom.ui.primaryActionText,
              '&:hover': {
                backgroundColor: (theme) => theme.custom.ui.primaryActionHover,
              },
            }}
          >
            Exportar
          </Button>

        </DialogActions>
      </Dialog>


      {/* Dialog para mostrar los detalles de la fila */}
      <Dialog
        open={openDialog}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
          setOpenDialog(false);
        }}
        disableEscapeKeyDown
        maxWidth="md"
        fullWidth
        aria-labelledby="cesion-detalle-title"
        slotProps={{
          paper: {
            sx: (theme) => ({
              borderRadius: 8,
              backgroundColor: theme.custom.ui.modalBg,
              boxShadow: theme.custom.ui.modalShadow,
              border: `1px solid ${theme.custom.ui.borderSubtle}`,
            }),
          },
        }}
      >
        {/* Header */}
        <DialogTitle
          id="cesion-detalle-title"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 3,
            py: 2,
          }}
        >
          <Stack direction="row" spacing={1.2} alignItems="center">
            <RiSlackFill
              size={22}
              color="inherit"
            />
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                letterSpacing: '0.04em',
                color: (theme) => theme.custom.ui.brandAccent,
              }}
            >
              Detalles de la Cesión
            </Typography>
          </Stack>

          <Button
            onClick={() => setOpenDialog(false)}
            variant="contained"
            size="small"
            sx={{
              backgroundColor: (theme) =>
                theme.custom.ui.secondaryActionBg,
              color: (theme) =>
                theme.custom.ui.secondaryActionText,
              border: (theme) =>
                `1px solid ${theme.custom.ui.secondaryActionBorder}`,
              '&:hover': {
                backgroundColor: (theme) =>
                  theme.custom.ui.secondaryActionBgHover,
              },
            }}
          >
            Cerrar
          </Button>
        </DialogTitle>

        <Divider
          sx={{
            borderColor: (theme) => theme.custom.ui.borderSubtle,
            opacity: 0.9,
          }}
        />

        {/* CONTENIDO */}
        <DialogContent
          sx={{
            maxHeight: '75vh',
            overflowY: 'auto',
            px: 2,
            py: 2,
          }}
        >
          {rowDetails && (
            <Stack spacing={2}>
              {/* Datos del Contribuyente */}
              <Card
                sx={{
                  backgroundColor: (theme) => theme.custom.ui.surfaceBg,
                  borderRadius: 8,
                  boxShadow: (theme) =>
                    theme.custom.ui.surfaceShadow,
                }}
              >
                <CardHeader
                  title="Datos del la Cesión"
                  sx={{
                    py: 1.5,
                    backgroundColor: (theme) =>
                      theme.custom.ui.modalBg,
                    borderBottom: (theme) =>
                      `1px solid ${theme.custom.ui.borderSubtle}`,
                    '& .MuiCardHeader-title': {
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                      color: (theme) => theme.custom.ui.brandAccent,
                    },
                  }}
                />
                <CardContent sx={{ pt: 2 }}>
                  {[
                    ['Id Cesión', rowDetails.id],
                    ['Fecha Cesión', rowDetails.feccesion],
                    ['Rut Deudor', rowDetails.rutdeudor],
                    ['Razón Social', rowDetails.nomdeudor],
                    ['Dirección', rowDetails.domdeudor],
                  ].map(([label, value]) => (
                    <Stack
                      key={label}
                      direction="row"
                      spacing={2}
                      alignItems="flex-start"
                      // mb={1}
                    >
                      <Typography
                        sx={{
                          width: 160,
                          color: (theme) => theme.custom.ui.textSecondary,
                          fontSize: '0.85rem',
                          flexShrink: 0,
                        }}
                      >
                        {label}
                      </Typography>

                      <Typography
                        sx={{
                          color: (theme) => theme.custom.ui.textPrimary,
                          fontSize: '0.9rem',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {value ?? '-'}
                      </Typography>
                    </Stack>
                  ))}
                </CardContent>
              </Card>

              {/* Datos del Cedente */}
              <Card
                sx={{
                  backgroundColor: (theme) => theme.custom.ui.surfaceBg,
                  borderRadius: 8,
                  boxShadow: (theme) =>
                    theme.custom.ui.surfaceShadow,
                }}
              >
                <CardHeader
                  title="Datos Cedente"
                  sx={{
                    py: 1.5,
                    backgroundColor: (theme) =>
                      theme.custom.ui.modalBg,
                    borderBottom: (theme) =>
                      `1px solid ${theme.custom.ui.borderSubtle}`,
                    '& .MuiCardHeader-title': {
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                      color: (theme) => theme.custom.ui.brandAccent,
                    },
                  }}
                />

                <CardContent sx={{ pt: 2 }}>
                  {[
                    ['Rut Cedente', rowDetails.rutcedente],
                    ['Razón Social', rowDetails.nomcedente],
                    ['Dirección', rowDetails.domcedente],
                  ].map(([label, value]) => (
                    <Stack
                      key={label}
                      direction="row"
                      spacing={2}
                      alignItems="flex-start"
                      // mb={1}
                    >
                      <Typography
                        sx={{
                          width: 160,
                          color: (theme) => theme.custom.ui.textSecondary,
                          fontSize: '0.85rem',
                          flexShrink: 0,
                        }}
                      >
                        {label}
                      </Typography>

                      <Typography
                        sx={{
                          color: (theme) => theme.custom.ui.textPrimary,
                          fontSize: '0.9rem',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {value ?? '-'}
                      </Typography>
                    </Stack>
                  ))}
                </CardContent>
              </Card>


              {/* Datos del Cesionario */}
              <Card
                sx={{
                  backgroundColor: (theme) => theme.custom.ui.surfaceBg,
                  borderRadius: 8,
                  boxShadow: (theme) =>
                    theme.custom.ui.surfaceShadow,
                }}
              >
                <CardHeader
                  title="Datos Cesionario"
                  sx={{
                    py: 1.5,
                    backgroundColor: (theme) =>
                      theme.custom.ui.modalBg,
                    borderBottom: (theme) =>
                      `1px solid ${theme.custom.ui.borderSubtle}`,
                    '& .MuiCardHeader-title': {
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                      color: (theme) => theme.custom.ui.brandAccent,
                    },
                  }}
                />

                <CardContent sx={{ pt: 2 }}>
                  {[
                    ['Rut Cesionario', rowDetails.rutcesionario],
                    ['Razón Social', rowDetails.nomcesionario],
                    ['Dirección', rowDetails.domcesionario],
                  ].map(([label, value]) => (
                    <Stack
                      key={label}
                      direction="row"
                      spacing={2}
                      alignItems="flex-start"
                      // mb={1}
                    >
                      <Typography
                        sx={{
                          width: 160,
                          color: (theme) => theme.custom.ui.textSecondary,
                          fontSize: '0.85rem',
                          flexShrink: 0,
                        }}
                      >
                        {label}
                      </Typography>

                      <Typography
                        sx={{
                          color: (theme) => theme.custom.ui.textPrimary,
                          fontSize: '0.9rem',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {value ?? '-'}
                      </Typography>
                    </Stack>
                  ))}
                </CardContent>
              </Card>


              {/* Datos Nota de Crédito */}
              <Card
                sx={{
                  backgroundColor: (theme) => theme.custom.ui.surfaceBg,
                  borderRadius: 8,
                  boxShadow: (theme) =>
                    theme.custom.ui.surfaceShadow,
                }}
              >
                <CardHeader
                  title="Datos Nota Crédito"
                  sx={{
                    py: 1.5,
                    backgroundColor: (theme) =>
                      theme.custom.ui.modalBg,
                    borderBottom: (theme) =>
                      `1px solid ${theme.custom.ui.borderSubtle}`,
                    '& .MuiCardHeader-title': {
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                      color: (theme) => theme.custom.ui.brandAccent,
                    },
                  }}
                />

                <CardContent sx={{ pt: 2 }}>
                  {[
                    ['Folio Nota Crédito', rowDetails.folionc],
                    ['Fecha Emisión', rowDetails.feceminc],
                    ['Monto', rowDetails.montonc],
                  ].map(([label, value]) => (
                    <Stack
                      key={label}
                      direction="row"
                      spacing={2}
                      alignItems="flex-start"
                      // mb={1}
                    >
                      <Typography
                        sx={{
                          width: 160,
                          color: (theme) => theme.custom.ui.textSecondary,
                          fontSize: '0.85rem',
                          flexShrink: 0,
                        }}
                      >
                        {label}
                      </Typography>

                      <Typography
                        sx={{
                          color: (theme) => theme.custom.ui.textPrimary,
                          fontSize: '0.9rem',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {value ?? '-'}
                      </Typography>
                    </Stack>
                  ))}
                </CardContent>
              </Card>

              {/* Datos Estado de Pago */}
              <Card
                sx={{
                  backgroundColor: (theme) => theme.custom.ui.surfaceBg,
                  borderRadius: 8,
                  boxShadow: (theme) => theme.custom.ui.surfaceShadow,
                }}
              >
                <CardHeader
                  title="Datos Estado de Pago"
                  sx={{
                    py: 1.5,
                    backgroundColor: (theme) => theme.custom.ui.modalBg,
                    borderBottom: (theme) =>
                      `1px solid ${theme.custom.ui.borderSubtle}`,
                    '& .MuiCardHeader-title': {
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                      color: (theme) => theme.custom.ui.brandAccent,
                    },
                  }}
                />

                <CardContent sx={{ pt: 2 }}>
                  {[
                    [
                      'Estado',
                      rowDetails.pagada === 0
                        ? 'Pendiente'
                        : rowDetails.pagada === 1
                        ? 'En Nómina'
                        : 'Pagada'
                    ],
                    ['Comp. Pago Nro', rowDetails.idpago],
                    [
                      'Fecha de Pago',
                      rowDetails.fechapago
                        ? new Date(rowDetails.fechapago)
                            .toLocaleDateString('es-CL')
                        : '-'
                    ],
                    ['Cant. Documentos', rowDetails.cantidad],
                    ['Monto Total Comp', rowDetails.monto],
                    ['Conciliado', rowDetails.idpago],
                  ].map(([label, value]) => (
                    <Stack
                      key={label}
                      direction="row"
                      spacing={2}
                      alignItems="flex-start"
                      // mb={1}
                    >
                      <Typography
                        sx={{
                          width: 160,
                          color: (theme) => theme.custom.ui.textSecondary,
                          fontSize: '0.85rem',
                          flexShrink: 0,
                        }}
                      >
                        {label}
                      </Typography>

                      <Typography
                        sx={{
                          color: (theme) => theme.custom.ui.textPrimary,
                          fontSize: '0.9rem',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {value ?? '-'}
                      </Typography>
                    </Stack>
                  ))}
                </CardContent>
              </Card>
            </Stack>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Cesionesdeu;
